
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import StockOrderModule from "@/store/modules/barcodeSystem/stockOrder";
import notifications from "@/lib/notifications";
import { StockOrderListFilters } from "@/models/api/barcodeSystem/stockOrders/get";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const stockOrderModuleState = getModule(StockOrderModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class StockOrderFilters extends Vue {
  localFilters: StockOrderListFilters = null;

  get filters() {
    return stockOrderModuleState.filters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  async submit() {
    stockOrderModuleState.setFilters(JSON.parse(JSON.stringify(this.localFilters)));
    stockOrderModuleState.setLoading(true);
    try {
      await stockOrderModuleState.getStockOrders({
        pageNumber: 1,
        pageSize: stockOrderModuleState.pageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Stock Orders", "Failed to load stock orders", ex);
    }

    stockOrderModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return stockOrderModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
